import React from "react";

function NotesInput({
  value,
  onChange,
  minLength = 10,
  maxLength = 8192,
  label = "Notes",
  placeholder = "Document your rationale...",
  id,
  required = true,
  disabled = false,
  rows = 4,
}) {
  const trimmedLen = (value || "").trim().length;
  const tooShort = required && trimmedLen > 0 && trimmedLen < minLength;
  const valid = !required || trimmedLen >= minLength;

  return (
    <div className="field">
      <label className="field__label" htmlFor={id}>
        {label}{required ? " *" : ""}
      </label>
      <textarea
        id={id}
        className="field__textarea"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        rows={rows}
        style={tooShort ? { borderColor: "var(--neg-500)" } : undefined}
      />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: 8 }}>
        <span
          className="field__hint"
          style={{
            color: tooShort ? "var(--neg-500)" : valid ? "var(--pos-500)" : "var(--tx-3)",
          }}
        >
          {trimmedLen} chars · min {minLength} · max {maxLength}
        </span>
        {tooShort && (
          <span className="field__error">
            Minimum {minLength} characters required.
          </span>
        )}
      </div>
    </div>
  );
}

export default NotesInput;
